var map = {
	"./Dashboard-additional-1-fi.png": 16900,
	"./Dashboard-additional-2-fi.png": 87481,
	"./Dashboard-additional-5-fi.png": 28816,
	"./RecordObservation-additional-1-fi.png": 46351,
	"./RecordObservation-additional-11-fi.png": 51496,
	"./RecordObservation-additional-13-fi.png": 99410,
	"./RecordObservation-additional-17-fi.png": 87254,
	"./RecordObservation-additional-19-fi.png": 24464,
	"./RecordObservation-additional-2-fi.png": 7750,
	"./RecordObservation-additional-7-fi.png": 52941,
	"./RecordObservation-additional-9-fi.png": 94583,
	"./ServicedDevices-additional-13-sv.png": 97571,
	"./ServicedDevices-additional-14-en.png": 59620,
	"./ServicedDevices-additional-14-fi.png": 45930
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45513;